import { useState } from "react";
import { Nav } from "react-bootstrap";
import { MdDevices, MdOutlineDevices, MdOutlinePassword } from "react-icons/md";
import { TbAuth2Fa } from "react-icons/tb";
import { RiHistoryFill } from "react-icons/ri";
import { BiError } from "react-icons/bi";
import { ImProfile } from "react-icons/im";
import ManageProfile from "./ManageProfile";
import ChangePassword from "./ChangePassword";
import TwoFactorAuth from "./TwoFactorAuth";
import SetupAnotherDevice from "./SetupAnotherDevice";
import LinkedDevices from "./LinkedDevices";
import LoginHistory from "./LoginHistory";
import BruteForceAttackRecord from "./BruteForceAttackRecord";

const ProfileManagement = ({getCurrectLoginUser, currentUserData}) => {
  const [openModule, setOpenModule] = useState("manageProfile");
  const menuItems = [
    { key: "manageProfile", label: "Manage Profile", icon: <ImProfile /> },
    { key: "changePassword", label: "Change Password", icon: <MdOutlinePassword /> },
    { key: "twoFactorAuthentication", label: "2 Factor Authentication", icon: <TbAuth2Fa /> },
    { key: "setupAnotherDevices", label: "Setup Another Devices", icon: <MdOutlineDevices /> },
    { key: "linkedDevices", label: "Linked Devices", icon: <MdDevices /> },
    { key: "loginHistory", label: "Login History", icon: <RiHistoryFill /> },
    { key: "bruteforceAttack", label: "Brute Force Attack", icon: <BiError /> },
  ];
  return (
    <div className="w-100 hstack">
      <div
        style={{ height: "calc(100vh - 56px)", minWidth: 250 }}
        className="overflow-auto border-end"
      >
        <div className="p-3 pb-0">
          <h6>Profile Management</h6>
        </div>
        <Nav className="flex-column p-2 gap-1">
          {menuItems.map((item) => {
            const isActive = openModule === item.key;
            return (
              <Nav.Link
                key={item.key}
                title={item.label}
                onClick={() => {
                  setOpenModule(item.key);
                }}
                className={`sidebar-link ${isActive ? "active" : ""}`}
              >
                <span className="icon" style={{ fontSize: 14 }}>
                  {item.icon}
                </span>
                <span className="label" style={{ fontSize: 14 }}>
                  {item.label}
                </span>
              </Nav.Link>
            );
          })}
        </Nav>
      </div>
      <div className="w-100 bg-light overflow-auto" style={{ height: "calc(100vh - 56px)" }}>
        {openModule === "manageProfile" && <ManageProfile getCurrectLoginUser={getCurrectLoginUser} currentUserData={currentUserData} />}
        {openModule === "changePassword" && <ChangePassword />}
        {openModule === "twoFactorAuthentication" && <TwoFactorAuth openModule={openModule} />}
        {openModule === "setupAnotherDevices" && <SetupAnotherDevice />}
        {openModule === "linkedDevices" && <LinkedDevices />}
        {openModule === "loginHistory" && <LoginHistory />}
        {openModule === "bruteforceAttack" && <BruteForceAttackRecord />}
      </div>
    </div>
  );
};

export default ProfileManagement;
